export default {"src":"/_next/static/media/functional-yard.183e4c34.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};